import React from 'react';
import {ReactComponent as FrameScreenShotIcon} from "../../../assets/frame_screenshot_icon.svg";
// import {ReactComponent as CameraIcon} from "../../../assets/camera_icon.svg";
import {Box} from "@mui/material";

export const NonImagePlaceholder = () => {
    return (
        <Box
            title="Frame Screenshot"
            sx={{
                backgroundColor: "#D4DADE",
                width: "100%",
                height: "100%",
                display: "flex",
                flexFlow: "column",
            }}
        >
            <FrameScreenShotIcon
                style={{
                    height: "100%",
                    width: "100%",
                    // padding: "20%",
                    // height: "100%",
                }}
            />
        </Box>
    )
}